// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1935d980","455":"fe87139e","977":"e8b885ea"}[chunkId] + ".chunk.js";
};